export default __webpack_public_path__ + "assets/home-three-one-small.b6d9c2a3f1c7cc14ad01c9be17e2abc5.png";